import { CSSProperties, JSX } from "react";

export interface IconStorage {
  svgCode: SvgCodeFunc;
  svgProps?: {
    height: string;
    width: string;
  },
}

export type SvgCodeFunc = (color?: string, pathStyle?: CSSProperties) => (JSX.Element | string[]);

export const sharedLineIconProps = (color: string = "currentColor", pathStyle: CSSProperties): React.SVGAttributes<SVGElement> => ({
  stroke: color,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  style: pathStyle,
});
